import { Injectable } from '@angular/core';

declare let ga: Function, gaRegisterClicks: Function, ipcsadoReInit: Function, gtag: Function;

@Injectable()
export class AnalyticsService {
  public googleEmitEvent(eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
    let category = null;
    if (eventCategory) {
      category = eventCategory.toLowerCase();
    }

    let action = null;
    if (eventAction) {
      action = eventAction.toLowerCase();
    }

    let label = null;
    if (eventLabel) {
      label = eventLabel.toLowerCase();
    }

    try {
      ga('send', 'event', {
        eventCategory: category,
        eventLabel: label,
        eventAction: action,
        eventValue: eventValue
      });
    } catch { }
  }

  public googleEmitPageview(path: string) {
    try {
      ga('set', 'dimension9', new Date().getTime());
      ga('send', 'pageview', (location.pathname.toLowerCase() + path).replace(/\/\//g, '/'));
    } catch { }
    // Nieuwe GA4
    try {
      gtag('event', 'page_view', {
        page_title: document.title,
        page_location: location.href.toLowerCase().split('?')[0],
        page_path: (location.pathname.toLowerCase() + path).replace(/\/\//g, '/')
      })
    } catch { }
  }

  public celebrusReinit() {
    try {
      ipcsadoReInit();
    } catch { }

    setTimeout(() => {
      try {
        gaRegisterClicks();
      } catch { }
    });
  }
}
